// React
import { ReactElement } from 'react';
// Next
import { useRouter } from 'next/router';
// Modules
import classNames from 'classnames/bind';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { Link } from '@utmb/design-system/link/link';
// Contexts/Hooks
import { useDashboardNavigation } from '@utmb/design-system/use-dashboard-navigation/UseDashboardNavigation';
// Interfaces
import MyUtmbNavigationView from '@utmb/types/type/MyUtmbNavigationView';
// Styles
import styles from './navigation.module.scss';

const cx = classNames.bind(styles);

const Navigation = (): ReactElement | null => {
    const { route } = useRouter();
    const { dashboardNavigation, registrationNavigation } = useDashboardNavigation();

    if (!dashboardNavigation?.length && !registrationNavigation?.length) {
        return null;
    }

    // Reset Types for navigation
    const dashboardRoutes = dashboardNavigation?.length ? dashboardNavigation : (registrationNavigation as unknown as MyUtmbNavigationView[]);

    return (
        <ul className={styles.list}>
            {dashboardRoutes.map(({ id, label, icon, slug, disabled }) => {
                return (
                    <li key={id}>
                        {disabled ? (
                            <div
                                className={cx(styles.item, `${slug.replace('/my-utmb/', '')}`, {
                                    '-active': route === slug,
                                })}
                            >
                                <div className={styles.item_icon}>
                                    <Icon variant={icon} />
                                </div>
                                <Font.FuturaMedium desktop="14" className={styles.item_text}>
                                    {label}
                                </Font.FuturaMedium>
                            </div>
                        ) : (
                            <Link
                                href={slug}
                                className={cx(styles.item, `${slug.replace('/my-utmb/', '')}`, {
                                    '-active': route === slug,
                                })}
                            >
                                <div className={styles.item_icon}>
                                    <Icon variant={icon} />
                                </div>
                                <Font.FuturaMedium desktop="14" className={styles.item_text}>
                                    {label}
                                </Font.FuturaMedium>
                            </Link>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default Navigation;
